import React from "react";
import Input from "./form-input-dropdown-view"
import MetadataLayout from "../form-input/layout-metadata"


export default function Dropdown(props){
    return (<MetadataLayout {...props}>
            <Input {...props}/>
        </MetadataLayout>
    )
}